import { transformErrorResponse } from "../../transformErrorResponse"
import { ItemENTITY, ItemEspañaENTITY } from "sigo-entities"
import { LogisticaApiBuilder } from "."

export const Items = (build: LogisticaApiBuilder) => {
    return {
        findItemsEspaña: build.query<ItemEspañaENTITY[], { pipeline: any[] }>({
            query: ({ pipeline }) => ({
                url: `/Maestros/Items/find`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
        findItems: build.query<ItemENTITY[], { pipeline: any[] }>({
            query: ({ pipeline }) => ({
                url: `/Maestros/Items/find`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
    }
}